import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer id="contact" className="footer">
      <img
        src={process.env.PUBLIC_URL + "/Institute_Building.png"}
        alt=""
        className="footer-bg-logo"
      />
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-section">
              <h3>ICETTACS 2026</h3>
              <p>
                International Conference on Emerging Trends and Technologies in
                Applications of Computer Science
              </p>
              <p className="footer-tagline">
                Fostering Innovation, Interdisciplinary Research, and Global
                Collaboration
              </p>
            </div>

            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#about-conference">About Conference</a>
                </li>
                <li>
                  <a href="#tracks">Tracks</a>
                </li>
                <li>
                  <a href="#important-dates">Important Dates</a>
                </li>
                <li>
                  <a href="#registration">Registration</a>
                </li>
                <li>
                  <a href="#committee">Committee</a>
                </li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Important Dates</h4>
              <ul className="dates-list">
                <li>
                  <strong>Call for Papers:</strong> 15th January, 2026
                </li>
                <li>
                  <strong>Paper Submission:</strong> 31st May, 2026
                </li>
                <li>
                  <strong>Conference Dates:</strong> 9th - 10th July 2026
                </li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Contact & Venue</h4>
              <p>
                <strong>Venue:</strong>
                <br />
                Birla Institute of Technology (BIT)
                <br />
                Mesra - Lalpur Unit
                <br />
                Ranchi, Jharkhand, India - 834001
              </p>
              <p>
                <strong>Convenor:</strong>
                <br />
                Dr. Devesh Kumar Upadhyay
                <br />
                <a href="mailto:devesh@bitmesra.ac.in">devesh@bitmesra.ac.in</a>
                <br />
                <a href="tel:8802333408">8802333408</a>
              </p>
            </div>
            <div className="footer-section footer-section-map">
              <div className="map-responsive">
                <iframe
                  title="BIT Mesra (Lalpur) map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4636.151486682344!2d85.3385283774303!3d23.3717823612643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f4e1721c194ced%3A0xf02707411486a195!2sBIT%20Mesra%20(Lalpur)!5e1!3m2!1sen!2sin!4v1771493708875!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>
              &copy; 2026 ICETTACS 2026, Department of Computer Science and
              Engineering, BIT Mesra, India. All rights reserved.
            </p>
            <div className="footer-links">
              <a href="#privacy">Privacy Policy</a>
              <a href="#terms">Terms & Conditions</a>
              <a href="#contact">Contact Us</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
